export interface IIntRes {
  data: number;
}

export class IntRes implements IIntRes {
  public data: number;
}
